import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ResolutionDeletedAuditItemDetails = ({ audit }) => {
  const { auditedChanges } = audit
  const { text } = auditedChanges

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> deleted the resolution:
      </span>
      <div className="mt-4 whitespace-pre-wrap">
        { text }
      </div>
    </div>
  )
}

ResolutionDeletedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ResolutionDeletedAuditItemDetails
